type EventPayload = {
  afterRender: {
    payload?: Record<string, unknown>;
  };
};

const BundleEventListeners: Map<
  keyof EventPayload,
  Set<(payload?: EventPayload[keyof EventPayload]) => void>
> = new Map();

export const BundleEventProvider = {
  addEventListener: <T extends keyof EventPayload>(
    event: T,
    callback: (payload?: EventPayload[T]) => void
  ) => {
    if (!BundleEventListeners.has(event)) {
      BundleEventListeners.set(event, new Set());
    }
    BundleEventListeners.get(event)?.add(callback);
    return callback;
  },
  removeEventListener: <T extends keyof EventPayload>(
    event: T,
    callback: (payload?: EventPayload[T]) => void
  ) => {
    if (BundleEventListeners.has(event)) {
      BundleEventListeners.get(event)?.delete(callback);
    }
  },
  dispatchEvent: <T extends keyof EventPayload>(event: T, payload?: EventPayload[T]) => {
    const listeners = BundleEventListeners.get(event);
    if (listeners) {
      try {
        listeners.forEach((listener) => typeof listener === 'function' && listener(payload));
      } catch (error) {
        console.error(`Error dispatching event ${event}:`, error);
      }
    }
  },
};
